import * as React from 'react';
const InfoIcon = ({ width = 18, height = 18, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M9 17.063C4.553 17.063.938 13.448.938 9 .938 4.553 4.553.938 9 .938c4.448 0 8.063 3.615 8.063 8.062 0 4.448-3.615 8.063-8.063 8.063m0-15A6.946 6.946 0 0 0 2.063 9 6.946 6.946 0 0 0 9 15.938 6.946 6.946 0 0 0 15.938 9 6.946 6.946 0 0 0 9 2.063'
      fill='currentColor'
    />
    <path
      d='M9 10.313a.567.567 0 0 1-.562-.563V6c0-.307.255-.562.562-.562s.563.255.563.562v3.75a.567.567 0 0 1-.563.563m0 2.437a.8.8 0 0 1-.285-.06.9.9 0 0 1-.247-.157.8.8 0 0 1-.158-.248.8.8 0 0 1-.06-.285c0-.098.023-.195.06-.285a.9.9 0 0 1 .158-.248.9.9 0 0 1 .247-.157.75.75 0 0 1 .57 0q.135.056.248.157.101.113.157.248a.7.7 0 0 1 .06.285.8.8 0 0 1-.06.285.8.8 0 0 1-.157.248.9.9 0 0 1-.248.157.8.8 0 0 1-.285.06'
      fill='currentColor'
    />
  </svg>
);
export default InfoIcon;
